(() => {
  const buttons = document.querySelectorAll('.review__item button')
  if (buttons.length) {
    buttons.forEach(button => {
      const wrapper = button.closest('.review__item').querySelector('.desc__hidden')

      button.addEventListener('click', () => {
        wrapper.classList.toggle('hidden')
        wrapper.setAttribute('aria-hidden', wrapper.getAttribute('aria-hidden') === 'true' ? 'false' : 'true')

        button.setAttribute('aria-expanded', button.getAttribute('aria-expanded') === 'true' ? 'false' : 'true')
        button.querySelectorAll('.toggle').forEach(svg => svg.classList.toggle('hidden'))
      })
    })
  }
})()
